/*
状态对象
 */
export default {
  token:'', // 用户token
  hgtype:null, // 选中护工类型
  selectHgInfo:null,// 选中护工信息
  patientinfo:null,  // 选中患者的信息
}